import React, { useState } from 'react';
import { Search, Filter,  X } from 'lucide-react';
import { useDevis } from '../context/DevisContext';

const SearchBar = () => {
  const { searchTerm, setSearchTerm } = useDevis();
  const [focusedField, setFocusedField] = useState('');

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const clearSearch = () => {
    setSearchTerm('');
  };

  return (
    <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl border border-white/20 p-6">
      <div className="flex flex-col lg:flex-row gap-6 items-center">
        {/* Search Input */}
        <div className="flex-1 w-full">
          <div className="relative">
            <input
              type="text"
              placeholder="Rechercher par nom, email, téléphone..."
              value={searchTerm}
              onChange={handleSearch}
              onFocus={() => setFocusedField('search')}
              onBlur={() => setFocusedField('')}
              className={`w-full pl-12 pr-12 py-4 rounded-xl border-2 transition-all duration-300 ${focusedField === 'search'
                  ? "border-green-500 focus:border-green-500 focus:ring-green-200 bg-green-50"
                  : "border-gray-200 focus:border-green-500 focus:ring-green-200 bg-white"
                }`}
            />
            <Search
              className={`absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 transition-colors duration-300 ${focusedField === 'search' ? 'text-green-500' : 'text-gray-400'
                }`}
            />
            {searchTerm && (
              <button
                onClick={clearSearch}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400 hover:text-gray-600 transition-colors"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>

        {/* Filter and Sort Controls */}
        <div className="flex items-center space-x-4">
          {/* Filter Button */}
          <button className="group relative bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white px-6 py-4 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-xl overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-20 transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-all duration-700"></div>
            <div className="flex items-center space-x-2 relative z-10">
              <Filter className="w-5 h-5" />
              <span>Filtres</span>
            </div>
          </button>
        </div>
      </div>

      {/* Search Results Info */}
      {searchTerm && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2 text-sm text-gray-600">
              <Search className="w-4 h-4" />
              <span>Recherche pour: <span className="font-semibold text-gray-900">"{searchTerm}"</span></span>
            </div>
            <button
              onClick={clearSearch}
              className="text-sm text-green-600 hover:text-green-700 font-medium transition-colors"
            >
              Effacer la recherche
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;